module.exports = __webpack_public_path__ + "assets/term.98ecf0ed.svg";